import React, { Component } from 'react';
import { Icon, Spinner, translate, Checkbox } from '@haldor/ui';
import { Box } from '@mui/material';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import swal from 'sweetalert2';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { clearVerdicts, getVerdictScale } from 'actions/verdicts';
import { getSchoolSettings } from 'actions/schools';

import VerdictFeedbackForm from 'containers/Verdict/Form/Partials/VerdictFeedbackForm';
import VerdictLevelForm from 'containers/Verdict/Form/Partials/VerdictLevelForm';

import { getSchoolId } from 'lib/msal';
import { Button } from '@haldor/ui';
import '../Verdict.scss';
import User from '_class/User';

class VerdictForm extends Component {

	constructor(props) {
		super(props);

		let level = 0;
		let feedback = '';

		if (props.initialValues != null) {
			if (props.initialValues.scaleLevelId != null) {
				level = props.initialValues.scaleLevelId;
			}

			if (props.initialValues.feedback != null) {
				feedback = props.initialValues.feedback;
			}
		}

		this.state = {
			level,
			feedback,
			loading: true,
			id: null,
			visibleToGuardiansAndStudents: true,
			user: new User(this.props.currentUser)
		};
	}

	componentDidMount = async () => {
		let currentSchoolId = await getSchoolId();
		if (this.state.user != null && this.state.user.isTeacher() && this.props.schoolSettings == null || this.props.schoolSettings?.schoolId != currentSchoolId) {
			await this.props.getSchoolSettings();
		}

		if (this.props.scale == null) {
			await this.props.getVerdictScale();
		}

		if (this.props.schoolSettings != null) {
			this.setState({ visibleToGuardiansAndStudents: this.props.schoolSettings.defaultVerdictVisibility });
		}

		this.initForm();
	}
	componentDidUpdate(prevProps) {
		if (
			prevProps.userVerdicts !== this.props.userVerdicts &&
			Array.isArray(this.props.userVerdicts) &&
			this.props.userVerdicts.length > 0
		) {
			this.initForm();
		}
	}
	initForm = () => {
		let visibilitySettingEnabled = this.props.schoolSettings?.defaultVerdictVisibility;
		this.setState({ level: null, feedback: null, loading: true, visibleToGuardiansAndStudents: visibilitySettingEnabled ?? true, id: null }, () => {
			if (this.props.duplicate == true) {
				let verdict = this.props.sectionVerdicts.find(verdict => {
					return this.props.activeStudent == verdict.userId;
				});
				this.setState({ level: verdict.scaleLevelId, feedback: verdict.feedback, visibleToGuardiansAndStudents: verdict.visibleToGuardiansAndStudents, loading: false });
			} else if (this.props.userVerdicts != null && this.props.userVerdicts.length > 0) {
				const courseId = this.props.courseId;
				const latestVerdict =
					this.props.userVerdicts
						.filter(v => v.courses?.some(c => Number(c.courseID) === Number(courseId)))
						.sort((a, b) => new Date(b.created || 0) - new Date(a.created || 0))[0] || null;
				if (latestVerdict && latestVerdict.status == 'VERDICT_DRAFT') {
					this.setState({ level: latestVerdict.scaleLevelId, feedback: latestVerdict.feedback, id: latestVerdict.id, visibleToGuardiansAndStudents: latestVerdict.visibleToGuardiansAndStudents, });
				}

				this.setState({ loading: false });
			} else if (this.props.verdict != null) {
				this.setState({ level: this.props.verdict.scaleLevelId, feedback: this.props.verdict.feedback, id: this.props.verdict.id, visibleToGuardiansAndStudents: this.props.visibleToGuardiansAndStudents, loading: false });
			} else {
				this.setState({ loading: false });
			}
		});
	}

	submit = (values) => {
		return new Promise(resolve => {
			values.scaleLevelId = this.state.level;
			values.feedback = this.state.feedback;
			values.scaleId = this.props.scale.id;
			values.visibleToGuardiansAndStudents = this.state.visibleToGuardiansAndStudents;

			if (this.state.id != null)
				values.id = this.state.id;

			if (values.status == null) {
				values.status = 'VERDICT_PUBLISHED';
			}

			if (this.props.onSubmit != null) {
				this.props.onSubmit(values)
					.then(() => {
						if (values.status == "VERDICT_PUBLISHED") {
							this.setState({ level: 0, feedback: '' });
							this.props.reset();
						}
						this.initForm();
						resolve(1);
					});
			}
		});
	}

	deleteVerdictDraft = () => {
		swal.fire({
			title: this.props.translate('are-you-sure'),
			text: this.props.translate('are-you-sure-you-want-to-delete'),
			showCancelButton: true,
			cancelButtonText: this.props.translate('No'),
			confirmButtonText: this.props.translate('Yes'),
		}).then(async (result) => {
			if (result.value != null) {
				this.setState({ loading: true });
				await this.props.deleteVerdict(this.props.userVerdicts[0].id);
				this.setState({
					loading: false,
					level: 0,
					feedback: '',
					id: null
				});
			}
		});
	}

	toggleVisibleToGuardiansAndStudents = () => {
		this.setState({
			visibleToGuardiansAndStudents: !this.state.visibleToGuardiansAndStudents
		});
	}

	render() {
		const { submitting, handleSubmit, courseId } = this.props;
		const { feedback, level, loading } = this.state;

		if (loading) {
			return <Spinner center />;
		}

		let saveText = this.props.translate('Publish evaluation');
		let status = null;
		const latestVerdict =
			(this.props.userVerdicts || [])
				.filter(v => v.courses?.some(c => Number(c.courseID) === Number(courseId)))
				.sort((a, b) => new Date(b.created || 0) - new Date(a.created || 0))[0] || null;
		if (latestVerdict) {
			status = latestVerdict.status;
		}
		let invalid_group = this.props.group?.deleted || this.props.group?.archived;
		let invalid = level == 0 || level == null || invalid_group;

		let visibilitySettingEnabled = this.props.schoolSettings?.enableVerdictVisibilitySetting;
		let permissionClass = visibilitySettingEnabled ? "permission-active" : "permission-inactive";

		return (
			<div>
				{submitting ?
					<div className="is_sending" style={{ height: '100%', top: 0 }}>
						<p><span className="loading-spinner" /></p>
					</div>
					: null}

				{invalid_group ? <div className='info-box'>
					<span className="title">
						<Icon name="Alert" bw /> {this.props.translate('No evaluations can be created because the group is archived or deleted')}
					</span>
				</div> : null}

				<div className="form-container">
					<form onSubmit={handleSubmit(this.submit)} className="form form-component">
						<div className="form-row">
							{this.props.scale != null ?
								<VerdictLevelForm
									levels={this.props.scale.levels}
									value={level}
									onChange={level => this.setState({ level })}
									key={this.props.scale.id}
								/>
								: null}
						</div>

						<div className="form-row">
							<VerdictFeedbackForm
								value={this.state.feedback}
								onChange={feedback => this.setState({ feedback })}
							/>
						</div>

						<Box sx={{ mt: '1.35rem', ml: 0.7 }}>
							<Checkbox
								value={this.state.visibleToGuardiansAndStudents}
								onChange={(checked) => visibilitySettingEnabled && this.setState({ visibleToGuardiansAndStudents: checked })}
								disabled={!visibilitySettingEnabled}
								label={this.props.translate('Show the evaluation for students and guardians')}
							/>
							{!visibilitySettingEnabled && (
								<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 1, ml: 0.5, fontSize: '0.875rem', color: '#666' }}>
									<InfoOutlinedIcon sx={{ fontSize: '16px' }} />
									<span>{this.props.translate('The option to change the setting is disabled by your school. For support, contact your school administrator.')}</span>
								</Box>
							)}
						</Box>

						<div className="form-row submit" style={{ marginTop: '1.25rem', marginBottom: '1.25rem' }}>
							<Button onClick={handleSubmit(values => { console.log(values); this.submit({ ...values, status: 'VERDICT_PUBLISHED' }) })} disabled={invalid}>
								{saveText}
							</Button>

							{this.props.edit == false ?
								<Button onClick={handleSubmit(values => this.submit({ ...values, status: 'VERDICT_DRAFT' }))} disabled={invalid}>
									{this.props.translate('save-draft')}
								</Button>
								: null}

							{status == 'VERDICT_DRAFT' ?
								<Button onClick={(e) => { e.preventDefault(); this.deleteVerdictDraft() }} type="secondary">
									{this.props.translate('Delete')}
								</Button>
								: null}

							<div className="clearfix"></div>
						</div>
					</form>
				</div >
			</div >
		);
	}

}

function mapStateToProps(state) {
	return {
		translate: translate(state.Languages.translations),
		scale: state.Verdicts.scale,
		sectionVerdicts: state.Verdicts.section,
		currentUser: state.user.currentUser,
		schoolSettings: state.School.schoolSettings,
	};
}

export default connect(mapStateToProps, {
	getVerdictScale,
	clearVerdicts,
	getSchoolSettings
})(reduxForm({
	form: 'VerdictForm',
	destroyOnUnmount: true,
})(VerdictForm));
